import { UnleashClient } from 'unleash-proxy-client'
import Config from '@/config'
import sentry from '@/3rd-parties/sentry'

class UnleashService {
  constructor() {
    try {
      this.unleashClient = new UnleashClient({
        url: 'https://features.ahaslides.com/api/proxy',
        clientKey: Config.unleashClientKey,
        appName: 'presenter',
        createAbortController: () => null,
      })

      this.unleashClient.start()
    } catch (error) {
      sentry.captureException(error)
      this.unleashClient = null
    }
  }

  isFeatureEnabled(featureName) {
    if (!this.unleashClient) {
      return false
    }

    try {
      return this.unleashClient.isEnabled(featureName)
    } catch (error) {
      return false
    }
  }

  getVariant(featureName) {
    if (!this.unleashClient) {
      return { name: 'disabled', enabled: false }
    }

    try {
      return this.unleashClient.getVariant(featureName)
    } catch (error) {
      return { name: 'disabled', enabled: false }
    }
  }
}

export default new UnleashService()
